module.exports = __webpack_public_path__ + "img/arrow_down.486b1f53.svg";